function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import TypeUtils from "./utils/type";
import ActionsRunMultiple from "./actions/runMultiple";
import ActionsFormsSubmitV1 from "./actions/forms/submit";
import ActionsHttpGetV1 from "./actions/http/get";
import ActionsHttpPostV1 from "./actions/http/post";
import ActionsHttpPatchV1 from "./actions/http/patch";
import ActionsHttpDeleteV1 from "./actions/http/delete";
import ActionsDialogsAlert from "./actions/dialogs/alert"; // import ActionsDialogsConfirm from "./actions/dialogs/confirm"

import ActionsDialogsShow from "./actions/dialogs/show";
import ActionsDialogsOpen from "./actions/dialogs/open";
import ActionsDialogsClose from "./actions/dialogs/close";
import ActionsDialogsReload from "./actions/dialogs/reload";
import ActionsDialogsOptions from "./actions/dialogs/options";
import ActionsDialogsNotification from "./actions/dialogs/notification";
import ActionsDialogsOauth from "./actions/dialogs/oauth";
import ActionsSnackbarsAlert from "./actions/snackbars/alert"; // import ActionsSnackbarsConfirm from "./actions/snackbars/confirm"

import ActionsSnackbarsSelect from "./actions/snackbars/select";
import ActionsSheetsSelect from "./actions/sheets/select";
import ActionsWindowsClose from "./actions/windows/close";
import ActionsWindowsCloseAll from "./actions/windows/closeAll";
import ActionsWindowsOpen from "./actions/windows/open";
import ActionsWindowsOpenWeb from "./actions/windows/openWeb";
import ActionsWindowsReload from "./actions/windows/reload";
import ActionsWindowsCloseWithReload from "./actions/windows/closeWithReload";
import ActionsWindowsRefreshState from "./actions/windows/refreshState";
import ActionsWindowsPrint from "./actions/windows/print";
import ActionsPanelsScrollToBottom from "./actions/panels/scrollToBottom";
import ActionsPanelsScrollTo from "./actions/panels/scrollTo";
import ActionsWsPush from "./actions/ws/push";
import ActionsCablesPush from "./actions/cables/push";
import ActionsTimeoutsSet from "./actions/timeouts/set";
import ActionsAuthSaveCsrfToken from "./actions/auth/saveCsrfToken";
import ActionsAuthRestart from "./actions/auth/restart";
import ActionsCreditCard from "./actions/auth/creditCard";
import ActionsAnalyticsLogEvent from "./actions/analytics/logEvent";
import ActionCommandsCopy from "./actions/commands/copy";
import ActionToursStart from "./actions/tours/start";
import ActionComponentsUpdate from "./actions/components/update";
var actions = {
  runMultiple: ActionsRunMultiple,
  "forms/submit": ActionsFormsSubmitV1,
  "http/get": ActionsHttpGetV1,
  "http/post": ActionsHttpPostV1,
  "http/patch": ActionsHttpPatchV1,
  "http/delete": ActionsHttpDeleteV1,
  "dialogs/alert": ActionsDialogsAlert,
  // "dialogs/confirm": ActionsDialogsConfirm,
  "dialogs/show": ActionsDialogsShow,
  "dialogs/open": ActionsDialogsOpen,
  "dialogs/close": ActionsDialogsClose,
  "dialogs/reload": ActionsDialogsReload,
  "dialogs/options": ActionsDialogsOptions,
  "dialogs/notification": ActionsDialogsNotification,
  "dialogs/oauth": ActionsDialogsOauth,
  "snackbars/alert": ActionsSnackbarsAlert,
  // "snackbars/confirm": ActionsSnackbarsConfirm,
  "snackbars/select": ActionsSnackbarsSelect,
  "sheets/select": ActionsSheetsSelect,
  "windows/close": ActionsWindowsClose,
  "windows/closeAll": ActionsWindowsCloseAll,
  "windows/open": ActionsWindowsOpen,
  "windows/openWeb": ActionsWindowsOpenWeb,
  "windows/reload": ActionsWindowsReload,
  "windows/closeWithReload": ActionsWindowsCloseWithReload,
  "windows/refreshState": ActionsWindowsRefreshState,
  "windows/print": ActionsWindowsPrint,
  "panels/scrollToBottom": ActionsPanelsScrollToBottom,
  "panels/scrollTo": ActionsPanelsScrollTo,
  "timeouts/set": ActionsTimeoutsSet,
  "ws/push": ActionsWsPush,
  "cables/push": ActionsCablesPush,
  "auth/saveCsrfToken": ActionsAuthSaveCsrfToken,
  "auth/restart": ActionsAuthRestart,
  "auth/creditCard": ActionsCreditCard,
  "analytics/logEvent": ActionsAnalyticsLogEvent,
  "commands/copy": ActionCommandsCopy,
  "tours/start": ActionToursStart,
  "components/update": ActionComponentsUpdate
};

var Action = /*#__PURE__*/function () {
  function Action() {
    _classCallCheck(this, Action);
  }

  _createClass(Action, null, [{
    key: "execute",
    value: function execute(spec, component) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (!TypeUtils.isObject(spec)) {
        return;
      }

      var name = spec.action;

      if (TypeUtils.isString(name)) {
        if (name.startsWith("component/")) {
          this.executeLocal(name, spec, component);
        } else {
          this.executeGlobal(name, spec, component, params);
        } // const actionName = name.replace(/-v1$/, "");
        // try {
        //   const action = new actions[actionName]();
        //   const logDisabled = action.logDisabled && action.logDisabled();
        //   if (!logDisabled) {
        //     console.log(`Executing "${actionName}"`);
        //   }
        //   action.execute(spec, null, component, params);
        // } catch (e) {
        //   console.log(`Failed executing command: "${e.message}"`);
        // }

      } else {
        console.log("Invalid action: \"".concat(name, "\""));
      }
    }
  }, {
    key: "executeLocal",
    value: function executeLocal(name, spec, component) {
      var methodName = name.replace(/^component\//, "");
      var componentName = Utils.app.vueName(component);
      console.log("Executing component action on ".concat(componentName, ": ").concat(methodName));
      component["action_".concat(methodName)](spec);
    }
  }, {
    key: "executeGlobal",
    value: function executeGlobal(name, spec, component, params) {
      var actionName = name.replace(/-v1$/, "");

      try {
        var action = new actions[actionName]();
        var logDisabled = action.logDisabled && action.logDisabled();

        if (!logDisabled) {
          console.log("Executing \"".concat(actionName, "\""));
        }

        action.execute(spec, component, params);
      } catch (e) {
        console.log("Failed executing command", actionName, "Error: '".concat(e.message, "'"));
      }
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(response, component, url) {
      // TODO: The execution should be in the following order: onResponse, page render, onLoad
      if (response.header || response.body || response.footer) {
        Utils.http.forceComponentUpdate(function () {
          window.vueApp.page = response;
        });
      }

      window.vueApp.temp.analytics = response.analytics;
      GLib.action.execute(response.onResponse, component);
      window.vueApp.temp.analytics = null;
    }
  }]);

  return Action;
}();

export { Action as default };
window.Action = Action;